
import Vue from "vue";
import Api from "@/services/Api";
import { Overlay } from "@/lib/Overlay";
import { AxiosResponse } from "axios";
import { VMoney } from "v-money";
import moment from "moment";
import { TableOptions } from "@/models/TableOptions";
import { SwapQuote } from "@/models/SwapQuote";
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";

//@ts-ignore
import  walletAddressValidator from "@getdelta/wallet-address-validator";
import { isAddress, getAddress } from "ethers/lib/utils";

export interface Swaps {
  id: string;
  swap: any;
}
export default Vue.extend({
  name: "NewSwap",

  data() {
    return {
      loadingBalance: false,
      saldoDisponivel: "0,00",
      showSaldo: false,
      transactionPin: "",
      btnloading: false,
      OkCreateSwap: false,
      dialogConfirmSwap: false,
      QuoteRespJWT: [],
      showAmountToPayUSDT: true,
      showNetInverseRateAmountOut: false,
      netInverseRateAmountOut: "R$ 1 = 0,000000 USDT",
      netRateAmountOut: "1 USDT = R$ 0,000000",
      amountIn: {
        amountIn: "0.0000",
        amountInFormatado: "0,00",
        amountInUSD: "0,00",
        amountInEUR: "0,00",
      },
      ticketPrice: "1 USDT = R$ 0,000000",
      netAmountOut: {
        netAmountOut: "0.000000",
        netAmountOutFormatado: "0,00",
        netAmountOutEURFormatado: "0,00",
        netAmountOutUSDFormatado: "0,00",
      },
      dialogSwap: false,
      serviceTax: "0,00",
      serviceTaxPerc: "0",

      withdrawTax: "0,00",
      blockchainTax: "0",
      addressOut: "",
      addressOutPlaceholder: "0x48d17...",
      defaultBtnCurrencyIn: {
        icon: require("@/assets/images/brl.svg"),
        namePt: "Real",
        sigla: "BRL",
      },
      defaultBtnCurrencyOut: {
        icon: require("@/assets/images/usdt.svg"),
        namePt: "Tether",
        sigla: "USDT",
      },
      defaultBtnNetWorkOut: {
        icon: require("@/assets/images/eth.svg"),
        namePt: "Ethereum (ERC20)",
      },
      rules: {
        required: (value: string) => !!value || "Required.",
      },
      errors: [] as any,
      swapExactFiatForCrypto: false,
      swapFiatForExactCrypto: false,
      formQuote: {} as SwapQuote,

      loadingDesserts: true,
      totalDesserts: 0,
      options: {} as TableOptions,
      search: "",
      moment: moment,
      lang: navigator.language,
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      timeout: 0,
      markets: [], //JSON.parse(localStorage.getItem("SwapMarkets")),
      isMobile: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      moneyBTC: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 6,
        masked: false /* doesn't work with directive */,
      },

      currencies: [] as any,
      marketsBTC: [] as any,
      marketsUSDT: [] as any,
      defaultMarket: [] as any,
      user: "",
      amountInBrl: "",
      netAmountOutBTC: "",
      okToQuote: true,
      countDown: 60,
      countDownCount: 0,
      countDownStart: true,
    };
  },
  created() {
    this.isMobile = this.detectMobile();

    this.getCurrencies();

    this.formQuote.currencyIn = "BRL";
    this.formQuote.currencyOut = "USDT";
    this.formQuote.networkOut = "eth-mainnet";
    this.formQuote.netAmountOut = this.netAmountOut.netAmountOut;
    // this.countDownTimer();
    this.countDownStart = false;
  },

  methods: {
    openDialoQuote() {
      this.resetFieldsQuote();
      this.getBalanceSwap();

      this.dialogSwap = true;
      this.countDownStart = false;
    },
    resetFieldsQuote() {
      this.dialogConfirmSwap = false;
      this.OkCreateSwap = false;
      this.btnloading = false;
      this.amountInBrl = "";
      this.netAmountOutBTC = "";
      let inputNetAmountOut =
        (document.getElementById("BTC") as HTMLInputElement) || {};
      inputNetAmountOut.value = "0";
      let inputAmountIn =
        (document.getElementById("BRL") as HTMLInputElement) || {};
      inputAmountIn.value = "0";
      this.formQuote.currencyIn = "BRL";
      this.formQuote.currencyOut = "USDT";
      this.formQuote.networkOut = "eth-mainnet";
      this.formQuote.amountIn = "";
      this.formQuote.netAmountOut = "";

      this.netInverseRateAmountOut = "R$ 1 = 0,000000 USDT";
      this.netRateAmountOut = "1 USDT = R$ 0,000000";
      (this.amountIn = {
        amountIn: "0.0000",
        amountInFormatado: "0,00",
        amountInUSD: "0,00",
        amountInEUR: "0,00",
      }),
      (this.ticketPrice = "1 USDT = R$ 0,000000");
        this.netAmountOut = {
        netAmountOut: "0.00000000",
        netAmountOutFormatado: "0,00",
        netAmountOutEURFormatado: "0,00",
        netAmountOutUSDFormatado: "0,00",
      };
      this.transactionPin = "";
      this.QuoteRespJWT = [];
      this.serviceTax = "0,00";
      this.serviceTaxPerc = "0";
      this.withdrawTax = "0,00";
      this.blockchainTax = "0";
      this.addressOut = "";
      this.countDownStart = false;
      this.countDownCount = 0;
    },
    openDialogConfirmSwap() {
      if (this.addressOut.length < 10) {
        this.errors["addressOut"] = "Carteira inválida";
        return false;
      }
      this.dialogConfirmSwap = true;
      //  this.dialogSwap = false;
    },
    cancelConfirmSwap() {
      // Remover a chamada para resetFieldsQuote
      //this.resetFieldsQuote();
      this.transactionPin = "";
      this.dialogConfirmSwap = false;
      this.dialogSwap = true;
    },
    cancelSwap() {
      this.resetFieldsQuote();
      this.OkCreateSwap = false;
      this.dialogSwap = false;
    },
    createSwap() {
      this.btnloading = true;

      this.errors = [];

      if (this.transactionPin.length < 6) {
        this.errors["transactionPin"] = "Pin de transações inválido";
        this.btnloading = false;
        return false;
      }
      this.OkCreateSwap = false;
      this.countDownStart = false;

      Overlay.show();
      this.btnloading = true;
      this.dialogConfirmSwap = false;
      Api.post("/v2/client/cripto/swaps/swap", {
        transactionPin: this.transactionPin,
        addressOut: this.addressOut,
        userId: sessionStorage.getItem("userCriptoId"),
        quoteData: this.QuoteRespJWT,
      })
        .then((response) => {
          this.dialogConfirmSwap = false;
          this.dialogSwap = false;
          this.addressOut = "";
          Swal.fire({
            title: "Conversão criada com sucesso",
            text: "Por favor, aguarde processamento",
            icon: "success",
          });
          this.$emit("callmethod", 0);
          this.resetFieldsQuote();
          this.countDownStart = false;
          this.dialogSwap = false;
          this.dialogConfirmSwap = false;
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          if (status != 200) {
            Swal.fire({
              title: "Opps",
              text: data.body.error,
              icon: "error",
            });
          }
          this.dialogConfirmSwap = false;
          this.resetFieldsQuote();
          this.OkCreateSwap = false;
          // this.resetRecaptcha();
        })
        .finally(() => {
          Overlay.hide();
          this.btnloading = false;
          this.OkCreateSwap = true;
          this.okToQuote = true;
          this.dialogConfirmSwap = false;
        });
    },
    //crypto para real
    fnSwapFiatForExactCrypto() {
      this.errors = [];

      this.swapExactFiatForCrypto = false;
      this.swapFiatForExactCrypto = true;

      this.formQuote.type = "swapFiatForExactCrypto";
    },
    //real para crypto
    fnSwapExactFiatForCrypto() {
      this.errors = [];

      this.swapExactFiatForCrypto = true;
      this.swapFiatForExactCrypto = false;
      this.formQuote.type = "swapExactFiatForCrypto";
    },
    makeBtnCurrencIn(icon: string, namePt: string, sigla: string) {
      this.defaultBtnCurrencyIn.icon = require("@/assets/images/" +
        icon.toLocaleLowerCase() +
        ".svg");
      this.defaultBtnCurrencyIn.namePt = namePt;
      this.defaultBtnCurrencyIn.sigla = sigla;

      this.formQuote.currencyIn = sigla;
    },
    makeBtnCurrencyOut(item: any) {
      this.defaultBtnCurrencyOut.icon = require("@/assets/images/" +
        item.currency.toLocaleLowerCase() +
        ".svg");
      this.defaultBtnCurrencyOut.namePt = item.name;
      this.defaultBtnCurrencyOut.sigla = item.currency;
      this.defaultMarket = item.deposit.networks;

      if (item.currency === "BTC") {
        this.defaultBtnCurrencyOut.icon = require("@/assets/images/" +
          item.currency.toLocaleLowerCase() +
          ".svg");
        this.defaultBtnCurrencyOut.namePt = item.name;
        this.defaultBtnCurrencyOut.sigla = item.currency;
      }
      this.defaultBtnNetWorkOut.icon = require("@/assets/images/" +
        this.defaultMarket[0].currencySymbol.toLocaleLowerCase() +
        ".svg");
      this.defaultBtnNetWorkOut.namePt = this.defaultMarket[0].description;

      this.addressOutPlaceholder = this.defaultMarket[0].placeholder;

      // Adicionar verificação para garantir que a moeda de recebimento é mantida
      if (this.formQuote.currencyOut !== item.currency) {
        this.formQuote.currencyOut = item.currency;
      }

      this.formQuote.networkOut = this.defaultMarket[0].nameId;
      this.getQuote();
    },
    makeBtnNetworkOut(item: any) {
      this.addressOut = "";
      this.addressOutPlaceholder = item.placeholder;

      this.defaultBtnNetWorkOut.icon = require("@/assets/images/" +
        item.currencySymbol.toLocaleLowerCase() +
        ".svg");
      this.defaultBtnNetWorkOut.namePt = item.description;

      this.formQuote.networkOut = item.nameId;
    },

    detectMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    getMarkets() {
      this.loadingDesserts = true;
      Overlay.show();
      Api.get("/v2/client/cripto/swaps/markets")
        .then((response) => {
          this.markets = response.data.data;

          const markets = response.data.data;
          for (let index = 0; index < markets.length; index++) {
            const element = markets[index];

            if (element.baseCurrency.currency === "USDT") {
              this.marketsUSDT = markets[index].baseCurrency.withdraw
                .networks as any;
              this.defaultMarket = this.marketsUSDT;
            }
            if (element.baseCurrency.currency === "BTC") {
              this.marketsBTC = markets[index].baseCurrency.withdraw.networks;
            }
          }
        })
        .finally(() => {
          Overlay.hide();
          this.loadingDesserts = false;
          this.dialogSwap = false;
          this.getBalanceSwap();
        });
    },
    getCurrencies() {
      this.loadingDesserts = true;
      Overlay.show();
      Api.get("/v2/client/cripto/swaps/currencies")
        .then((response) => {
          this.currencies = response.data.data;

          localStorage.removeItem("SwapCurrencies");
          localStorage.setItem(
            "SwapCurrencies",
            JSON.stringify(response.data.data)
          );
        })
        .finally(() => {
          this.getMarkets();
          Overlay.hide();
          this.loadingDesserts = false;
        });
    },
    removeFormatacaoMoeda($str: string) {
      return $str.replace(/\D/g, "");
    },
    validaAmountIn() {
      const valorAmountIn = this.removeFormatacaoMoeda(this.amountInBrl);

      if (
        valorAmountIn === "000" ||
        valorAmountIn === "0" ||
        valorAmountIn === "00" ||
        valorAmountIn === ""
      ) {
        return false;
      }
      return true;
    },
    validaAmountOut() {
      const valorNetAmountOut = this.removeFormatacaoMoeda(
        this.netAmountOutBTC
      );
      if (
        valorNetAmountOut === "000000000" ||
        valorNetAmountOut === "0000000" ||
        valorNetAmountOut === "000" ||
        valorNetAmountOut === "0" ||
        valorNetAmountOut === "00" ||
        valorNetAmountOut === ""
      ) {
        return false;
      }
      return true;
    },
    countDownTimer() {
      if (this.countDownStart && this.countDownCount <= 5) {
        setTimeout(() => {
          if (this.countDown > 0 && this.countDownStart) {
            this.countDown -= 1;
            this.countDownTimer();
          }

        }, 1000);

        if (this.countDown == 0) {
          this.countDownCount += 1;
          this.countDown = 20;
          this.countDownStart = false;
          this.getQuote();
        }
        if (this.countDownCount == 5) {
          this.resetFieldsQuote();
          this.countDownStart = false;
        }
      }
    },
    getQuote() {
      this.errors = [];
      this.QuoteRespJWT = [];
      this.btnloading = true;
      this.OkCreateSwap = false;

      setTimeout(() => {
        //deault values
        let postParams = {};
        if (this.swapExactFiatForCrypto) {
          if (!this.validaAmountIn()) {
            return false;
          }
          postParams = {
            amountIn: this.amountInBrl
              .replace("R$", "")
              .replace(" ", "")
              .trim(),
            currencyIn: this.formQuote.currencyIn,
            currencyOut: this.formQuote.currencyOut,
            networkOut: this.formQuote.networkOut,
            user: sessionStorage.getItem("userCriptoId"),
            type: this.formQuote.type,
          };
        } else {
          if (!this.validaAmountOut()) {
            return false;
          }
          postParams = {
            netAmountOut: this.netAmountOutBTC,
            currencyIn: this.formQuote.currencyIn,
            currencyOut: this.formQuote.currencyOut,
            networkIn: this.formQuote.currencyIn === "BRL" ? "p2p-mainnet" : (this.formQuote as any).networkIn,
            networkOut: this.formQuote.networkOut,
            user: sessionStorage.getItem("userCriptoId"),
            type: this.formQuote.type,
          };
        }
        this.loadingDesserts = true;
        this.okToQuote = false;
        Api.get("/v2/client/cripto/swaps/quote", {
          params: postParams,
        })
          .then((response) => {
            const dataResp = jwtDecode(response.data.body.quote) as any;
            this.QuoteRespJWT = response.data.body.quote;

            if (dataResp.data.status === "ok") {
              this.$nextTick(() => {
                let inputNetAmountOut = document.getElementById(
                  "BTC"
                ) as HTMLInputElement;
                inputNetAmountOut.value =
                  dataResp.data.data.quote.netAmountOut.netAmountOut;
                let inputAmountIn = document.getElementById(
                  "BRL"
                ) as HTMLInputElement;
                inputAmountIn.value =
                  dataResp.data.data.quote.amountIn.amountInFormatado;
              });

              this.netAmountOut = dataResp.data.data.quote.netAmountOut;
              this.amountIn = dataResp.data.data.quote.amountIn;

              this.serviceTax = dataResp.data.data.quote.fees.service.amount;
              this.serviceTaxPerc =
                dataResp.data.data.quote.fees.service.percentage.toString();

              this.blockchainTax =
                dataResp.data.data.quote.fees.networkOut.amount +
                " " +
                dataResp.data.data.quote.fees.networkOut.currency;
              this.netRateAmountOut =
                "1 " +
                dataResp.data.data.quote.netRateCurrencyOut +
                " = R$  " +
                dataResp.data.data.quote.netRateAmountOut;

              this.netInverseRateAmountOut =
                "R$ 1 = " +
                dataResp.data.data.quote.netInverseRateAmountOut +
                " " +
                dataResp.data.data.quote.netRateCurrencyOut;

              this.withdrawTax = response.data.body.withdrawTax;
              this.OkCreateSwap = true;
              this.countDownStart = true;
              this.countDown = 45; //aqui
              this.countDownTimer();
            }
          })
          .catch((error: any) => {
            this.OkCreateSwap = false;
            const response = error.response as AxiosResponse;
            const status = response.status;
            const data = response.data;

            if (status === 422) {

              const _this = this;
              setTimeout(function () {
                _this.netAmountOutBTC =
                  data.body.quote.data.quote.netAmountOut.netAmountOut;
              }, 500);
              this.errors = data.body.errors;
            } else {
              if (data.body.error === "Amount_Negative_Error_50") {
                this.errors["amountIn"] =
                  "Não é possível realizar a cotação com valor negativo.";
              } else {
                Swal.fire({
                  text: data.body.error,
                  icon: "error",
                  confirmButtonText: "Ok",
                  showConfirmButton: true,
                  customClass: {
                    confirmButton: "d-block",
                  },
                });
              }
            }
          })
          .finally(() => {
            Overlay.hide();

            this.loadingDesserts = false;
            this.btnloading = false;
            setTimeout(() => {
              this.okToQuote = true;
            }, 3000);
          });
      }, 500);
    },
    getCurrencySymbol(symbol: string) {
      return require(`@/assets/images/${symbol.toLocaleLowerCase()}.svg`);
    },
    getBalanceSwap() {
      this.loadingBalance = true;

      Api.get("/v2/client/cripto/swaps/balance")
        .then((response) => {
          this.saldoDisponivel = response.data.body.swapBalanceFormatado;
        })
        .finally(() => {
          this.loadingBalance = false;
        });
    },
    doDelayedQuote() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.getQuote();
        this.okToQuote = true;
      }, 500);
    },
    addressValidate(address: string, network: string) {
      if ((address ?? "").trim() === "") {
        throw new Error("address is required");
      }
      if ((network ?? "").trim() === "") {
        throw new Error("network is required");
      }
      const _network = (['bsc', 'polygon'].includes(network.split("-")[0].toLowerCase()) ? 'eth' : network.split("-")[0].toLowerCase());
      const _address = (_network === 'eth' && isAddress(address.toLowerCase())) ? getAddress(address.toLowerCase()) : address;
      return {
        address: _address,
        network: network,
        isValid: walletAddressValidator.validate(_address, _network),
      }
    },

  },
  watch: {
    addressOut: {
      handler(){
        let netWorkSelect = (this.defaultBtnNetWorkOut.namePt !== null || this.defaultBtnNetWorkOut.namePt !== '' || typeof this.defaultBtnNetWorkOut.namePt !== undefined)? this.defaultBtnNetWorkOut.namePt : 'ETH';
        netWorkSelect = (netWorkSelect === 'Ethereum (ERC20)')? netWorkSelect.slice(netWorkSelect.length, -8): netWorkSelect;
        netWorkSelect = (netWorkSelect !== 'Polygon' && netWorkSelect !== 'TRON')? 'Ethereum' : netWorkSelect;
        const validAddress = (this.addressOut !== '')? this.addressValidate(this.addressOut, netWorkSelect).isValid : false;
        
        if(parseFloat(this.amountIn.amountIn) >= 1 && validAddress === true) {
          this.OkCreateSwap = true;
          this.errors["addressOut"] = null;
        } else {
          this.errors["addressOut"] = "Carteira do Destinatário inválida ou rede incompatível.";
          this.OkCreateSwap = false;
        }
        if(validAddress === true){
          this.errors["addressOut"] = null;
        }
      }
    },
    amountInBrl: {
      handler() {
        if (!this.validaAmountIn()) {
          return false;
        }
        if (this.okToQuote) {
          this.fnSwapExactFiatForCrypto();
          this.doDelayedQuote();
        }
      },
    },
    netAmountOutBTC: {
      handler() {
        if (!this.validaAmountOut()) {
          return false;
        }
        if (this.okToQuote) {
          this.fnSwapFiatForExactCrypto();
          this.doDelayedQuote();
        }
      },
    },
  },
  directives: { money: VMoney, moneyBTC: VMoney },
});
